/**
 * the breadcrumb style
 */
export default {
    baseStyle: {
        container: {
            textStyle: ['body-small'],
            color: 'text.secondary',
        },
        price: {
            textDecoration: 'line-through',
        },
        label: {
            display: 'block',
        },
    },
    variants: {
        recommended: {
            container: {
                textStyle: ['body-xsmall'],
                whiteSpace: 'nowrap',
                flexDir: 'row',
            },
        },
    },
}
